module.exports = __webpack_public_path__ + "2a405a1d7f9ed93845adc899888d163f.ico";


//////////////////
// WEBPACK FOOTER
// ./static/images/sites/ride/favicon.ico
// module id = 1849
// module chunks = 1